import React from 'react'

import Home from "./Home/index"
import PrivacyPolicy from './PrivacyPolicy'
import TermsOfService from './TermsOfService'
import NotFound from "./NotFound"
import LandingPage from "./LandingPage"

const routes = [
    { path: "/", element: <Home /> },
    {
        path: "/privacy_policy",
        element: <PrivacyPolicy />
    },

    {
        path: "/terms_services",
        element: <TermsOfService />
    },
    {
        path: "/landingpage",
        element: <LandingPage />
    },
    {
        path: "*",
        element: <NotFound />
    }
]

export default routes;